import { render, staticRenderFns } from "./modalCalificacionesGenerales.vue?vue&type=template&id=656a5557"
import script from "./modalCalificacionesGenerales.vue?vue&type=script&lang=js"
export * from "./modalCalificacionesGenerales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports